import { render, staticRenderFns } from "./ElectronDiscoveryViz.vue?vue&type=template&id=48a9c0db&scoped=true"
import script from "./ElectronDiscoveryViz.vue?vue&type=script&lang=js"
export * from "./ElectronDiscoveryViz.vue?vue&type=script&lang=js"
import style0 from "./ElectronDiscoveryViz.vue?vue&type=style&index=0&id=48a9c0db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a9c0db",
  null
  
)

export default component.exports